import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { DeploymentTable } from '@/components/features/releases';

export function DeploymentsPage() {
  return (
    <>
      <Meta title="Deployments" />

      <Container className="space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Moving a published build into an environment, one stage at a time.
        </p>
        <DeploymentTable />
      </Container>
    </>
  );
}
